import React from 'react'
import "./flag.scss"
import '../../../styles/fontSizes.scss'
import palette from "styles/palette.scss"
import Text from '../../atoms/text/text';

const Flag = ({className, data, textSize}) =>{
    
    return(
        <>
            <div className = {`${className} flag__container font-size--${textSize}`}>
                <a target={"_blank"} href={data.href} className = "flag__color"></a>
                <div>
                    <Text color ={palette.white} type={"h"} textSize={2}>{data.title.substring(0,50)}</Text>
                    <Text color ={palette.white} type={"p"} textSize={2}>{data.description.substring(0,100) + "[...]"}</Text>
                </div>
            </div>
        </>
    )
}

export default Flag;